module.exports = __webpack_public_path__ + "static/media/6.703ca641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/6.jpg
// module id = 197
// module chunks = 0